import { render, staticRenderFns } from "./modal-administrative-pendency.vue?vue&type=template&id=38989daa&scoped=true"
import script from "./modal-administrative-pendency.ts?vue&type=script&lang=ts&external"
export * from "./modal-administrative-pendency.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-administrative-pendency.scss?vue&type=style&index=0&id=38989daa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38989daa",
  null
  
)

export default component.exports